<template>
  <div class="place-card" :class="{'min-step': step === 'min'}" @touchstart="touchstart" @touchmove="touchmove" @touchend="touchend">
    <div class="header">
      <button class="back-button" @click="$router.go(-1)">
        <img :src="util.getImagePath(`back_white@2x.png`)" :srcset="util.getImageSet(`back_white`)">
      </button>
      <div class="title" :class="{full: detail && !detail.permission.edit && !detail.permission.delete}" @click="$emit('clickHeader')">
        <div class="primary">{{ displayPrimaryNameOnTitle }}</div>
        <div class="secondary">{{ displaySecondaryNameOnTitle }}</div>
      </div>
      <button class="menu-button" v-if="detail && (detail.permission.edit || detail.permission.delete)">
        <img class="menu-button" :src="util.getImagePath(`more_light_black@2x.png`)" :srcset="util.getImageSet(`more_light_black`)">
      </button>
      <div class="menu-panel" v-show="isShowMenuPanel" v-on-clickaway="closeMenu">
        <button v-if="detail && detail.permission.edit" @click="clickEdit" :disabled="isPreparingEdit">
          <img :src="util.getImagePath(`edit_light_black@2x.png`)" :srcset="util.getImageSet(`edit_light_black`)" v-if="!isPreparingEdit">
          <div class="loading-img" v-if="isPreparingEdit">
            <div class="loading-animation primary"></div>
          </div>
          <div>{{ $t('PlaceCard.edit') }}</div>
        </button>

        <button v-if="detail && detail.permission.delete" @click="clickDelete">
          <img :src="util.getImagePath(`delete_light_black@2x.png`)" :srcset="util.getImageSet(`delete_light_black`)">
          <div>{{ $t('PlaceCard.delete') }}</div>
        </button>
      </div>
    </div>
    <!-- <TitleBar :text="displayNameOnTitle" :secondaryText="displayNameOnTitle" icon="back" :enableIconButton="true" @clickIconButton="$router.go(-1)" :showCloseButton="false" /> -->
    <div class="action-button-container">
      <button class="call-button" @click="call(0)" :class="{disable: detail !== undefined && 'promptpai_telephone' in detail ? (detail.promptpai_telephone === '') : true}">
        <img
        :src="util.getImagePath(`tel_${detail !== undefined && 'promptpai_telephone' in detail ? (detail.promptpai_telephone !== '' ? 'orange' : 'grey') : 'grey'}@2x.png`)"
        :srcset="util.getImageSet(`tel_${detail !== undefined && 'promptpai_telephone' in detail ? (detail.promptpai_telephone !== '' ? 'orange' : 'grey') : 'grey'}`)">
        <label>{{ $t('PlaceCard.tel') }}</label>
      </button>
      <button class="fav-button" @click="fav">
        <img style="padding: 0px;" :src="util.getImagePath('star_outline_orange@2x.png')" :srcset="util.getImageSet('star_outline_orange')" v-if="!isFav && !isMakingFav">
        <div class="fav-loading-animation" :class="{reverse: isFav}" v-if="isMakingFav"></div>
        <img style="padding: 0px;" :src="util.getImagePath('star_orange@2x.png')" :srcset="util.getImageSet('star_orange')" v-if="isFav && !isMakingFav">
        <label>{{ $t('PlaceCard.favorite') }}</label>
      </button>
      <button class="share-button" @click="share">
        <img :src="util.getImagePath('share_orange@2x.png')" :srcset="util.getImageSet('share_orange')">
        <label>{{ $t('PlaceCard.share') }}</label>
      </button>
      <button class="qr-button" @click="qr">
        <img :src="util.getImagePath('qr_orange@2x.png')" :srcset="util.getImageSet('qr_orange')">
        <label>{{ $t('PlaceCard.qr') }}</label>
      </button>
    </div>
    <div ref="detail" class="detail" :class="{'max-step': step === 'max'}" @click="$emit('clickBodyDetail')">
      <div class="loading-animation primary" v-if="detail === undefined && !isFinished"></div>
      <div class="error-message" v-if="detail === undefined && isFinished">{{ errorMessage }}</div>
      <div class="detail-list" v-if="detail">
        <!-- <div class="field">
          <div class="icon-container">
            <img :src="util.getImagePath('pp_dark_blue@2x.png')" :srcset="util.getImageSet('pp_dark_blue')">
          </div>
          <label>{{ displayId }}</label>
        </div> -->
        <div class="promtpai-code" v-if="detail">
          <div>
            <transition name="fade">
              <div class="copied" v-if="isShowCopiedPromptpaiId" v-html="$t('PlaceCard.copy')"></div>
            </transition>
            <iframe ref="promptpai-id-iframe"
              :key="'promptpai-id-iframe-' + countUpdate"
              @load="bindPromptPaiIdIframe"
              :src="`/ws/promptpai-link?pp_id=${detail.promptpai_id}&code_type=id&size=normal&button_style=button&theme=light&locale=${$i18n.locale}&title=${$t('PlaceCard.iframeTitle')}&version=1.0&count_update=${countUpdate}`"
              width="116" height="26" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"
            />
          </div>
          <div v-if="detail.telephone_list.filter(t => t.is_pp_tel_no).length > 0">
            <transition name="fade">
              <div class="copied" v-if="isShowCopiedPromptpaiTel" v-html="$t('PlaceCard.copy')"></div>
            </transition>
            <iframe ref="promptpai-tel-iframe"
              :key="'promptpai-tel-iframe-' + countUpdate"
              @load="bindPromptPaiTelIframe"
              :src="`/ws/promptpai-link?pp_id=${detail.promptpai_id}&code_type=phone&size=normal&button_style=button&theme=light&locale=${$i18n.locale}&title=${$t('PlaceCard.iframeTitle')}&version=1.0&count_update=${countUpdate}`"
              width="120" height="26" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"
            />
          </div>
        </div>
        <div class="field tel" v-if="detail.promptpai_telephone !== ''">
          <div class="icon-container">
            <img :src="util.getImagePath('tel_dark_blue@2x.png')" :srcset="util.getImageSet('tel_dark_blue')">
          </div>
          <label>
            <span v-for="(tel, i) in telList" :key="`${i}-${tel.tel}`">
              <span class="can-call" @click="call(i)" data-nosnippet v-html="`<!--googleoff: all-->${tel.tel_no}<!--googleon: all-->`"></span>
              <span class="to" v-if="tel.tel_no_to !== ''">{{ `-${tel.tel_no_to}` }}</span>
              <span class="ext" v-if="tel.ext !== ''">{{ `${$t('PlaceCard.ext')} ${tel.ext}` }}</span>
            </span>
          </label>
        </div>
        <div class="field">
          <div class="icon-container">
            <img :src="util.getImagePath('icon_place_blue@2x.png')" :srcset="util.getImageSet('icon_place_blue')">
          </div>
          <label>{{ detail.promptpai_address[`address_${$i18n.locale}`].replace(/undefined/g, '') }}</label>
        </div>
        <div class="field" v-if="detail.promptpai_address[`address_detail_${$i18n.locale}`].replace(/undefined/g, '') !== ''">
          <div class="icon-container">
            <img :src="util.getImagePath('icon_info_blue.svg')">
          </div>
          <label>{{ detail.promptpai_address[`address_detail_${$i18n.locale}`].replace(/undefined/g, '') }}</label>
        </div>
        <div class="field working" v-if="detail.working_hours_list.length > 0">
          <div class="icon-container">
            <img :src="util.getImagePath('time_blue@2x.png')" :srcset="util.getImageSet('time_blue')">
          </div>
          <label>
            <div v-for="(working, i) in detail.working_hours_list" :key="`${i}-${working.day}`">
              <div class="day">{{ $t(`PlaceCard.${working.day}`) }}</div>
              <div class="start">{{ working.start }}</div>
              <div class="to">-</div>
              <div class="end">{{ working.end === '24:00' ? '23:59' : working.end }}</div>
            </div>
          </label>
        </div>
        <div class="field website" v-if="detail.website">
          <div class="icon-container">
            <img :src="util.getImagePath('website_blue@2x.png')" :srcset="util.getImageSet('website_blue')">
          </div>
          <label><a @click="openWebsite(detail.website)">{{ detail.website }}</a></label>
        </div>
        <div class="log">
          <div class="creater" v-if="(detail.promptpai_creator || '') !== ''">{{ `${$t('PlaceCard.by')} ${detail.promptpai_creator}` }}</div>
          <div class="update-date-time">{{ `${$t('PlaceCard.update')}: ${displayUpdateDate} ${displayUpdateTime}` }}</div>
        </div>
      </div>
      <!-- <div class="image-list" v-if="detail && 'promptpai_images' in detail" ref="imageList" :style="{height: `${imageListHeight}px`}">
        <div class="count-image" v-if="detail.promptpai_images.length > 4" :style="{height: `${imageListHeight}px`, width: `${imageListHeight}px`}" @click="clickImage(3)">
          {{ `${detail.promptpai_images.length - 4}+` }}
        </div>
        <div class="image-container" v-for="(image, index) in detail.promptpai_images.slice(0, 4)" :key="`image-${image.image_id}`" :class="{'not-first': index !== 0}">
          <img @click="clickImage(index)" :src="`${image.imagepath}/128`" :srcset="`${image.imagepath}/128 1x, ${image.imagepath}/256 2x, ${image.imagepath}/384 3x, ${image.imagepath}/512 4x`" v-if="index < 4">
        </div>
      </div> -->
      <div class="image-list" v-if="detail" ref="imageList">
        <div class="image-container add" :style="imageListHeight > 0 ? {height: `${imageListHeight}px`} : ''" @click="clickAddImage">
          <img :src="util.getImagePath('add_photo_blue@2x.png')" :srcset="util.getImageSet('add_photo_blue')">
          <input ref="add-image-input" class="add-image-input" type="file" accept="image/*" @change="manageImageList()" v-show="false" multiple>
        </div>
        <template v-for="(image, index) in detail.promptpai_images">
          <div class="image-container" :style="imageListHeight > 0 ? {height: `${imageListHeight}px`} : ''" v-if="'promptpai_images' in detail" :key="`image-${image.image_id}`">
            <img @click="clickImage(index)" v-show="!image.deleted" v-if="imageListHeight > 0" :src="`${image.imagepath}/${imageListHeight / 2 * 4}`" :srcset="`${image.imagepath}/${imageListHeight} 1x, ${image.imagepath}/${imageListHeight * 2} 2x, ${image.imagepath}/${imageListHeight * 3} 3x, ${image.imagepath}/${imageListHeight * 4} 4x`">
          </div>
        </template>
      </div>

      <!-- <div v-show="detail" ref="shadow-on-map" class="shadow-on-map"></div>
      <div v-if="detail" id="place-map" ref="placeMap"></div>
      <button v-if="detail" ref="current-location-button" class="current-location-button" @click="clickCurrentLocationButton">
        <img :src="util.getImagePath('here_white@2x.png')" :srcset="util.getImageSet('here_white')">
      </button>
      <button v-if="detail" ref="zoom-in-button" class="zoom-in-button" @click="clickZoomInButton">
        <img :src="util.getImagePath('zoom_in_white@2x.png')" :srcset="util.getImageSet('zoom_in_white')">
      </button>
      <button v-if="detail" ref="zoom-out-button" class="zoom-out-button" @click="clickZoomOutButton">
        <img :src="util.getImagePath('zoom_out_white@2x.png')" :srcset="util.getImageSet('zoom_out_white')">
      </button> -->
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway'
import TitleBar from '@/components/TitleBar.vue'

export default {
  name: 'PlaceCard',
  components: {
    TitleBar
  },
  directives: {
    onClickaway: onClickaway
  },
  metaInfo () {
    var self = this
    return self.detail ? {
      title: self.$root.$i18n.locale === 'th' ? `${self.detail.promptpai_name_th} : พร้อมไป (PromptPai)` : `${self.detail.promptpai_name_en} : PP Code`,
      meta: [
        {
          name: 'description',
          content: self.$root.$i18n.locale === 'th' ? `รหัสพร้อมไป ${self.id} ${self.detail.promptpai_name_th} ${self.detail.promptpai_address.address_th} ${self.detail.promptpai_name_en} ${self.detail.promptpai_address.address_en}` : `PP Code ${self.id} ${self.detail.promptpai_name_en} ${self.detail.promptpai_address.address_en} ${self.detail.promptpai_name_th} ${self.detail.promptpai_address.address_th}`
        },
        {
          name: 'keywords',
          content: `พร้อมไป, PromptPai, ${self.detail.promptpai_name_th}, ${self.detail.promptpai_name_en}`
        },
        {
          property: 'fb:app_id',
          content: '148173948530677'
        },
        {
          property: 'og:type',
          content: 'place'
        },
        {
          property: 'place:location:latitude',
          content: self.detail.promptpai_location.lat
        },
        {
          property: 'place:location:longitude',
          content: self.detail.promptpai_location.lon
        },
        {
          property: 'og:site_name',
          content: 'PromptPai'
        },
        {
          property: 'og:image',
          content: self.detail.promptpai_images.length > 0 ? `${self.detail.promptpai_images[0].imagepath}/730x382` : `https://mmmap15.longdo.com/mmmap/snippet/?map=epsg3857&locale=th&height=191&width=365&HD=1&zoom=14&marker=position:${self.detail.promptpai_location.lat},${self.detail.promptpai_location.lon};offsetX:center;offsetY:bottom;icon:https://promptpai.com/static/image/my_place_pin_blue.png`
        },
        {
          property: 'og:image:type',
          content: 'image/png'
        },
        {
          property: 'og:url',
          content: self.detail.promptpai_url
        },
        {
          property: 'og:description',
          content: self.$root.$i18n.locale === 'th' ? `รหัสพร้อมไป ${self.id} ${self.detail.promptpai_name_th} ${self.detail.promptpai_address.address_th} ${self.detail.promptpai_name_en} ${self.detail.promptpai_address.address_en}` : `PP Code ${self.id} ${self.detail.promptpai_name_en} ${self.detail.promptpai_address.address_en} ${self.detail.promptpai_name_th} ${self.detail.promptpai_address.address_th}`
        },
        {
          property: 'og:title',
          content: self.$root.$i18n.locale === 'th' ? `${self.detail.promptpai_name_th} : พร้อมไป (PromptPai)` : `${self.detail.promptpai_name_en} : PP Code`
        }
      ]
    } : {}
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    callback: {
      type: Function,
      default: undefined
    },
    step: {
      type: String,
      default: 'mid'
    }
  },
  data () {
    return {
      detail: undefined,
      isFav: false,
      isMakingFav: false,
      placeMap: undefined,
      imageListHeight: 0,
      telList: [],
      isFinished: false,
      errorMessage: '',
      isShowMenuPanel: false,
      isShowCopiedPromptpaiId: false,
      isShowCopiedPromptpaiTel: false,
      imageList: [],
      touchstartClientY: null,
      previousClientY: null,
      countUpdate: 0,
      isPreparingEdit: false
    }
  },
  mounted () {
    var self = this
    self.$root.$on('updatePlaceCard', () => {
      if (self.id !== '') {
        self.description(self.id)
      }
    })
    self.$root.$on('deleteImage', self.deleteImage)
    if (self.id !== '') {
      self.description(self.id)
    }
    self.$root.$on('windowResize', self.updateHeight)
  },
  computed: {
    displayPrimaryNameOnTitle () {
      var self = this
      return self.detail ? self.detail[`promptpai_name_${self.$i18n.locale}`] : ''
    },
    displaySecondaryNameOnTitle () {
      var self = this
      return self.detail ? self.detail[`promptpai_name_${self.$i18n.locale === 'th' ? 'en' : 'th'}`] : ''
    },
    displayId () {
      var self = this
      if (self.id) {
        return `${self.id.substring(0, 4)} ${self.id.substring(4, 8)}`
      } else {
        return ''
      }
    },
    displayUpdateDate () {
      var self = this
      if (!self.detail) {
        return ''
      }
      var month = [
        {
          th: 'ม.ค.',
          en: 'Jan'
        },
        {
          th: 'ก.พ.',
          en: 'Feb'
        },
        {
          th: 'มี.ค.',
          en: 'Mar'
        },
        {
          th: 'เม.ย.',
          en: 'Apr'
        },
        {
          th: 'พ.ค.',
          en: 'May'
        },
        {
          th: 'มิ.ย.',
          en: 'Jun'
        },
        {
          th: 'ก.ค.',
          en: 'Jul'
        },
        {
          th: 'ส.ค.',
          en: 'Aug'
        },
        {
          th: 'ก.ย.',
          en: 'Sep'
        },
        {
          th: 'ต.ค.',
          en: 'Oct'
        },
        {
          th: 'พ.ย.',
          en: 'Nov'
        },
        {
          th: 'ธ.ค.',
          en: 'Dec'
        }
      ]
      var date = new Date(Number(self.detail.lastupdate) * 1000)
      return `${date.getDate()} ${month[date.getMonth()][self.$root.$i18n.locale]} ${`${(Number(date.getFullYear()) + (self.$root.$i18n.locale === 'th' ? 543 : 0))}`.substr(-2)}`
    },
    displayUpdateTime () {
      var self = this
      if (!self.detail) {
        return ''
      }
      var date = new Date(Number(self.detail.lastupdate) * 1000)
      return `${date.getHours()}:${`0${date.getMinutes()}`.substr(-2)}`
    }
  },
  methods: {
    async clickEdit () {
      var self = this
      var extractResult = {}
      self.isPreparingEdit = true

      // extract address th
      if (self.detail.promptpai_address.address_th !== '') {
        var result = await self.pp.extractAddress({
          text: self.detail.promptpai_address.address_th
        })
        result = result || {}
        if (result.status || null === 200) {
          extractResult = result.data.data.length > 0 ? result.data.data[0] : {}
          self.detail.promptpai_address.house_no = self.detail.promptpai_address.house_no || extractResult.house_no.trim()
          self.detail.promptpai_address.moo = self.detail.promptpai_address.moo || extractResult.moo.trim()
          self.detail.promptpai_address.village_th = self.detail.promptpai_address.village_th || extractResult.village.name.trim()
          self.detail.promptpai_address.condo_th = self.detail.promptpai_address.condo_th || extractResult.condominium.name.trim()
          self.detail.promptpai_address.building_th = self.detail.promptpai_address.building_th || extractResult.building.name.trim()
          self.detail.promptpai_address.floor = self.detail.promptpai_address.floor || extractResult.floor.trim()
          self.detail.promptpai_address.room = self.detail.promptpai_address.room || extractResult.room.trim()
          self.detail.promptpai_address.alley_th = self.detail.promptpai_address.alley_th || extractResult.alley.name.trim()
          self.detail.promptpai_address.road_th = self.detail.promptpai_address.road_th || extractResult.road.name.trim()
          self.detail.promptpai_address.country_th = self.detail.promptpai_address.country_th || extractResult.country.trim()
          self.detail.promptpai_address.postcode = self.detail.promptpai_address.postcode || extractResult.postcode.trim()
          self.detail.promptpai_address.subdistrict_th = self.detail.promptpai_address.subdistrict_th || extractResult.subdistrict.name.trim()
          self.detail.promptpai_address.district_th = self.detail.promptpai_address.district_th || extractResult.district.name.trim()
          self.detail.promptpai_address.province_th = self.detail.promptpai_address.province_th || extractResult.province.name.trim()

          const addressDetailList = []
          // if (self.detail.promptpai_address.village_th) {
          //   addressDetailList.push(self.detail.promptpai_address.village_th)
          // }
          // if (self.detail.promptpai_address.building_th) {
          //   addressDetailList.push(self.detail.promptpai_address.building_th)
          // }
          if (self.detail.promptpai_address.address_detail_th) {
            addressDetailList.push(self.detail.promptpai_address.address_detail_th)
          }
          self.detail.promptpai_address.address_detail_th = addressDetailList.join(', ')
        }
      }

      // extract address en
      if (self.detail.promptpai_address.address_en !== '') {
        result = await self.pp.extractAddress({
          text: self.detail.promptpai_address.address_en
        })
        result = result || {}
        if (result.status || null === 200) {
          extractResult = result.data.data.length > 0 ? result.data.data[0] : {}
          self.detail.promptpai_address.house_no = self.detail.promptpai_address.house_no || extractResult.house_no.trim()
          self.detail.promptpai_address.moo = self.detail.promptpai_address.moo || extractResult.moo.trim()
          self.detail.promptpai_address.village_en = self.detail.promptpai_address.village_en || extractResult.village.name.trim()
          self.detail.promptpai_address.condo_en = self.detail.promptpai_address.condo_en || extractResult.condominium.name.trim()
          self.detail.promptpai_address.building_en = self.detail.promptpai_address.building_en || extractResult.building.name.trim()
          self.detail.promptpai_address.floor = self.detail.promptpai_address.floor || extractResult.floor.trim()
          self.detail.promptpai_address.room = self.detail.promptpai_address.room || extractResult.room.trim()
          self.detail.promptpai_address.alley_en = self.detail.promptpai_address.alley_en || extractResult.alley.name.trim()
          self.detail.promptpai_address.road_en = self.detail.promptpai_address.road_en || extractResult.road.name.trim()
          self.detail.promptpai_address.country_en = self.detail.promptpai_address.country_en || extractResult.country.trim()
          self.detail.promptpai_address.postcode = self.detail.promptpai_address.postcode || extractResult.postcode.trim()
          self.detail.promptpai_address.subdistrict_en = self.detail.promptpai_address.subdistrict_en || extractResult.subdistrict.name.trim()
          self.detail.promptpai_address.district_en = self.detail.promptpai_address.district_en || extractResult.district.name.trim()
          self.detail.promptpai_address.province_en = self.detail.promptpai_address.province_en || extractResult.province.name.trim()

          const addressDetailList = []
          // if (self.detail.promptpai_address.village_en) {
          //   addressDetailList.push(self.detail.promptpai_address.village_en)
          // }
          // if (self.detail.promptpai_address.building_en) {
          //   addressDetailList.push(self.detail.promptpai_address.building_en)
          // }
          if (self.detail.promptpai_address.address_detail_en) {
            addressDetailList.push(self.detail.promptpai_address.address_detail_en)
          }
          self.detail.promptpai_address.address_detail_en = addressDetailList.join(', ')
        }
      }

      if (self.detail.promptpai_address.country_en === 'Thailand') {
        self.detail.promptpai_address.country_th = 'ไทย'
      }

      if (
        self.detail.promptpai_address.subdistrict_th !== '' || self.detail.promptpai_address.district_th !== '' || self.detail.promptpai_address.province_th !== '' ||
        self.detail.promptpai_address.subdistrict_en !== '' || self.detail.promptpai_address.district_en !== '' || self.detail.promptpai_address.province_en !== ''
      ) {
        if (self.detail.promptpai_address.country_en === '') {
          self.detail.promptpai_address.country_en = 'Thailand'
        }
        if (self.detail.promptpai_address.country_th === '') {
          self.detail.promptpai_address.country_th = 'ไทย'
        }
      }

      self.$root.$emit('openModal', {
        name: 'CreatePlaceForm',
        location: self.detail.promptpai_location,
        promptpaiDescription: self.detail,
        mode: 'EDIT'
      })

      self.isPreparingEdit = false
    },
    clickDelete () {
      var self = this
      self.$root.$emit('openModal', {
        name: 'ConfirmDelete',
        promptpaiDescription: self.detail
      })
    },
    bindPromptPaiIdIframe () {
      var self = this
      var iframe = self.$refs['promptpai-id-iframe']
      var content = (iframe.contentWindow || iframe.contentDocument)
      if (content.document) {
        content = content.document
      }
      if (!content.querySelector('.pp-snippet-link')) {
        return
      }
      content.querySelector('.pp-snippet-link').addEventListener('click', (e) => {
        e.preventDefault()
        var textArea = document.createElement('textarea')
        textArea.value = content.querySelector('.pp-snippet-name').innerHTML.replace(/\s+/g, '')
        textArea.contenteditable = 'true'
        textArea.setAttribute('readonly', false)
        document.body.appendChild(textArea)

        var range = document.createRange()
        range.selectNodeContents(textArea)

        var s = window.getSelection()
        s.removeAllRanges()
        s.addRange(range)

        textArea.select()
        textArea.setSelectionRange(0, 999999)
        document.execCommand('copy')
        textArea.remove()

        self.isShowCopiedPromptpaiId = true
        setTimeout(() => {
          self.isShowCopiedPromptpaiId = false
        }, 2000)
        return false
      })
    },
    bindPromptPaiTelIframe () {
      var self = this
      var iframe = self.$refs['promptpai-tel-iframe']
      var content = (iframe.contentWindow || iframe.contentDocument)
      if (content.document) {
        content = content.document
      }
      if (!content.querySelector('.pp-snippet-link')) {
        return
      }
      content.querySelector('.pp-snippet-link').addEventListener('click', (e) => {
        e.preventDefault()
        var textArea = document.createElement('textarea')
        textArea.contenteditable = 'true'
        textArea.setAttribute('readonly', false)
        textArea.value = content.querySelector('.pp-snippet-name').innerHTML.replace(/\s+/g, '')
        document.body.appendChild(textArea)

        var range = document.createRange()
        range.selectNodeContents(textArea)

        var s = window.getSelection()
        s.removeAllRanges()
        s.addRange(range)

        textArea.select()
        textArea.setSelectionRange(0, 999999)
        document.execCommand('copy')
        textArea.remove()

        self.isShowCopiedPromptpaiTel = true
        setTimeout(() => {
          self.isShowCopiedPromptpaiTel = false
        }, 2000)
        return false
      })
    },
    closeMenu (e) {
      var self = this
      if (e.target.className.indexOf('menu-button') === -1) {
        self.isShowMenuPanel = false
      } else if (e.target.className.indexOf('menu-button') !== -1) {
        self.isShowMenuPanel = !self.isShowMenuPanel
      }
    },
    touchstart (e) {
      var self = this
      if (!self.isShowMenuPanel) {
        if (self.step !== 'max') {
          self.$emit('touchstartHeader', e)
        } else if (self.step === 'max' && self.$refs['detail'].scrollTop === 0) {
          self.touchstartClientY = e.changedTouches[0].clientY
        }
      }
    },
    touchmove (e) {
      var self = this
      if (!self.isShowMenuPanel) {
        if (self.step !== 'max') {
          self.$emit('touchmoveHeader', e)
        } else if (self.step === 'max' && self.$refs['detail'].scrollTop === 0) {
          if (e.changedTouches[0].clientY - self.touchstartClientY === 1) {
            self.$emit('touchstartHeader', e)
          }
          if (e.changedTouches[0].clientY - self.touchstartClientY > 1) {
            self.$emit('touchmoveHeader', e)
          }
        }
      }
    },
    touchend (e) {
      var self = this
      if (!self.isShowMenuPanel) {
        if (self.step !== 'max') {
          self.$emit('touchendHeader', e)
        } else if (self.step === 'max' && self.$refs['detail'].scrollTop === 0 && e.changedTouches[0].clientY - self.touchstartClientY > 1) {
          self.$emit('touchendHeader', e)
        }
      }
    },
    updateHeight () {
      var self = this
      if (self.detail === undefined) {
        return
      }
      // if (self.detail.promptpai_images.length > 0) {
      //   self.imageListHeight = (self.$refs['imageList'].clientWidth - 2) / 3
      //   self.$refs['imageList'].style.display = ''
      // } else {
      //   // self.$refs['imageList'].style.display = 'none'
      // }
      if (window.innerWidth > 420) {
        self.imageListHeight = (self.$refs['imageList'].clientWidth - 24) / 4
      } else {
        self.imageListHeight = (self.$refs['imageList'].clientWidth - 16) / 3
      }
      self.$refs['imageList'].style.display = ''

      // var namePrimaryHeight = (self.$refs['namePrimary'] !== undefined && 'clientHeight' in self.$refs['namePrimary'] ? self.$refs['namePrimary'].clientHeight : 0) + 10
      // var nameSecondaryHeight = (self.$refs['nameSecondary'] !== undefined && 'clientHeight' in self.$refs['nameSecondary'] ? self.$refs['nameSecondary'].clientHeight : 0) + 10
      // var telHeight = (self.$refs['tel'] !== undefined && 'clientHeight' in self.$refs['tel'] ? self.$refs['tel'].clientHeight : 0) + 10
      // var addressHeight = self.$refs['address'] !== undefined && 'clientHeight' in self.$refs['address'] ? self.$refs['address'].clientHeight : 0
      // self.$refs['placeMap'].style.height = `calc(100% - ${namePrimaryHeight + nameSecondaryHeight + telHeight + addressHeight + self.imageListHeight}px)`
      // self.placeMap.resize()
    },
    description (id) { // เดิมไม่ต้องส่ง id จะใช้ self.id ใส่ใน function ไว้เลย แต่เนื่องจากหากเข้ามาทาง /p/เบอร์โทร จะต้อง get description 2 ครั้ง ครั้งแรกด้วยเบอร์โทร และต่อด้วยรหัสพร้อมไปเพื่อเอาข้อมูล permission
      var self = this
      if (id) {
        var userProfile = {}
        var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
        var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
        if (isAuthenticated) {
          userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
          uuid = undefined
        }
        self.pp.getPromptpaiDescription(
          id,
          'name' in userProfile ? userProfile.name : undefined,
          'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
          uuid,
          'notiid' in self.$route.query ? self.$route.query.notiid : undefined,
          undefined,
          (result) => {
            if (result.status.code === 200) {
              if (result.data.length === 1) {
                result.data[0].promptpai_images.forEach((image) => {
                  image.deleted = false
                })
                if (!('permission' in result.data[0])) { // กรณีค้นด้วยเบอร์ แล้วพอเรียก service description promptpai จะไม่ได้ permission มาด้วย จึงต้องค้นใหม่อีกครั้งด้วย promptpai code
                  self.description(result.data[0].promptpai_id)
                  return
                }
                self.detail = result.data[0]
                self.isFav = self.detail.marked_favorite
                if (self.callback) {
                  self.callback(self.detail.promptpai_location)
                }
                if ('promptpai_telephone' in self.detail && self.detail.promptpai_telephone !== '') {
                  // self.telList = self.detail.promptpai_telephone.split(', ')
                  self.telList = self.detail.telephone_list
                }
              } else if (result.data.length > 1) {
                var path = `/map/search/${self.id}/@13.764955,100.538317,6,1,0`
                self.$router.replace({
                  path: path
                })
                return
              }
            } else if (result.status.code === 401) {
              self.loginAgain()
            } else if (result.status.code === 403) {
              self.errorMessage = result.status.text
            } else if (result.status.code === 404) {
              self.errorMessage = result.status.text
            } else {
              self.errorMessage = result.status.text
            }
            self.isFinished = true
            self.countUpdate++
          }
        )
      }
    },
    call (index) {
      var self = this
      if ('promptpai_telephone' in self.detail && self.detail.promptpai_telephone !== '') {
        var userAgent = self.util.getUserAgentMeta()
        var tel = self.detail.promptpai_telephone.split(', ')[index]
        var url = `tel:${tel}`
        if (userAgent === 'iOS application') {
          window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
        } else if (userAgent === 'Android application') {
          Android.tel(tel)
        } else {
          window.location = url
        }
        window.gtag('event', 'call', {'event_category': 'engagement', 'event_label': `call_to_${self.detail.promptpai_id}`})
      }
    },
    fav () {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (self.isMakingFav) {
        return
      }
      self.isMakingFav = true
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.pp.setFavoritePlaces(
        self.id,
        !self.isFav,
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        uuid,
        undefined,
        (result) => {
          if (result.status.code === 200) {
            if (result.data) {
              self.isFav = !self.isFav
              if (self.isFav) {
                self.$root.$emit('askForTransfer')
                window.gtag('event', 'favorite', {'event_category': 'engagement', 'event_label': `add_${self.id}_to_favorite`})
              } else {
                window.gtag('event', 'unfavorite', {'event_category': 'engagement', 'event_label': `remove_${self.id}_from_favorite`})
              }
              self.updateFavoriteList()
            }
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
          self.isMakingFav = false
        }
      )
    },
    share () {
      var self = this
      self.$root.$emit('openModal', {
        name: 'SharePlaceWidget',
        placeDetail: self.detail
      })
    },
    qr () {
      var self = this
      self.$root.$emit('openModal', {
        name: 'PlaceQrCard',
        placeDetail: self.detail
      })
    },
    initialMap () {
      // var self = this
      // if (window.longdo) {
      //   self.placeMap = new window.longdo.Map({
      //     placeholder: document.getElementById('place-map'),
      //     language: self.$i18n.locale,
      //     lastView: false
      //   })

      //   self.placeMap.Event.bind('ready', () => { // When map is ready to use
      //     self.placeMap.Ui.Fullscreen.visible(true)
      //     self.placeMap.placeholder().appendChild(self.$refs['shadow-on-map'])

      //     self.placeMap.Ui.BottomRight.classList.add('custom-bottom-right-map-ui')
      //     self.placeMap.Ui.BottomRight.insertBefore(self.$refs['zoom-out-button'], self.placeMap.Ui.BottomRight.firstChild)
      //     self.placeMap.Ui.BottomRight.insertBefore(self.$refs['zoom-in-button'], self.placeMap.Ui.BottomRight.firstChild)
      //     self.placeMap.Ui.BottomRight.insertBefore(self.$refs['current-location-button'], self.placeMap.Ui.BottomRight.firstChild)

      //     self.placeMap.resize()
      //   })

      //   self.placeMap.location(self.detail.promptpai_location)
      //   self.placeMap.Ui.DPad.visible(false)
      //   self.placeMap.Ui.Geolocation.visible(false)
      //   self.placeMap.Ui.LayerSelector.visible(false)
      //   self.placeMap.Ui.Toolbar.visible(false)
      //   self.placeMap.Ui.Zoombar.visible(false)
      //   self.placeMap.resize()

      //   var pinOption = {
      //     icon: {
      //       url: self.util.getImagePath('my_place_pin_blue.png'),
      //       urlHD: self.util.getImagePath('my_place_pin_blue@2x.png'),
      //       offset: {
      //         x: 27 / 2,
      //         y: 39
      //       },
      //       weigth: window.longdo.OverlayWeight.Top
      //     }
      //   }
      //   var pin = new window.longdo.Marker(self.detail.promptpai_location, pinOption)
      //   self.placeMap.Overlays.add(pin)
      // }
    },
    clickCurrentLocationButton () {
      var self = this
      self.placeMap.location('GEOLOCATION')
    },
    clickZoomInButton () {
      var self = this
      var zoom = self.placeMap.zoom()
      self.placeMap.zoom(++zoom, true)
    },
    clickZoomOutButton () {
      var self = this
      var zoom = self.placeMap.zoom()
      self.placeMap.zoom(--zoom, true)
    },
    clickImage (index) {
      var self = this
      window.gtag('event', 'view_item_list', {'event_label': `place_image_gallery_${self.id}`})
      self.$root.$emit('openModal', {
        name: 'PlaceImageGallery',
        imageList: self.detail.promptpai_images,
        index: index
      })
    },
    deleteImage (imageId) {
      var self = this
      var index = self.detail.promptpai_images.map(i => { return i.image_id }).indexOf(imageId)
      if (index !== -1) {
        self.detail.promptpai_images.splice(index, 1)
      }
    },
    updateFavoriteList () {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.setFavoritePage(1)
      self.pp.getFavoritePlaces(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        isAuthenticated ? undefined : uuid,
        self.itemsPerPage,
        self.itemsPerPage * (self.favoritePage - 1),
        undefined,
        (result) => {
          if (result.status.code === 200) {
            self.setFavoriteList(result.data)
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
        }
      )
    },
    clickAddImage () {
      var self = this
      if (!self.detail.permission.post_image) {
        self.$root.$emit('openModal', {
          name: 'Login'
        })
      } else {
        if (self.util.getUserAgentMeta() === 'iOS application' || self.util.getUserAgentMeta() === 'Android application') {
          // window.selectImageFile = (ref, base64List) => {
          //   for (var i = 0; i < base64List.length; i++) {
          //     base64List[i] = `data:image/png;base64,${base64List[i]}`
          //   }
          //   self.manageImageListForNativeApp(base64List)
          // }
          // window.blockSelectImageFile = () => {
          //   console.log('blockSelectImageFile')
          // }
          // window.location.href = 'https://native.selectImageFile?ref=placecard&multiple=1'
          self.$root.$emit('openModal', {
            name: 'AddPlaceImageForm',
            promptpaiDescription: self.detail,
            imageList: [],
            immediately: true
          })
        } else {
          self.$refs[`add-image-input`].click()
        }
      }
    },
    manageImageList () {
      var self = this
      self.imageList = []
      var imageFileList = self.$refs[`add-image-input`].files

      var loadImage = (index) => {
        return (e) => {
          self.util.resizeImage(e.target.result, 2048, 2048, self.imageList[index].orientation, (originalUrl) => {
            self.imageList[index].original = originalUrl
          })
          self.util.resizeImage(e.target.result, 640, 640, self.imageList[index].orientation, (previewUrl) => {
            self.imageList[index].preview = previewUrl
          })
        }
      }

      var orientationCallback = function (index) {
        return (orientation) => {
          self.imageList[index].orientation = orientation
          var reader = new FileReader()
          reader.onload = loadImage(index)
          reader.readAsDataURL(self.imageList[index].file)
        }
      }

      for (var i = 0; i < imageFileList.length; i++) {
        if (imageFileList[i]) {
          self.imageList.push({
            file: imageFileList[i],
            original: imageFileList[i],
            preview: '',
            comment: '',
            orientation: -1
          })
          // self.util.getOrientation(
          //   self.imageList[self.imageList.length - 1].file,
          //   orientationCallback(self.imageList.length - 1)
          // )
          orientationCallback(self.imageList.length - 1)(self.imageList[self.imageList.length - 1].orientation)
        }
      }

      self.$root.$emit('openModal', {
        name: 'AddPlaceImageForm',
        promptpaiDescription: self.detail,
        imageList: self.imageList
      })
      self.$refs[`add-image-input`].value = ''
    },
    manageImageListForNativeApp (base64List) {
      var self = this
      self.imageList = []

      var loadOriginalImage = (index) => {
        return (url) => {
          self.imageList[index].file = url
          self.imageList[index].original = url
        }
      }

      var loadImage = (index) => {
        return (previewUrl) => {
          self.imageList[index].preview = previewUrl
        }
      }

      for (var i = 0; i < base64List.length; i++) {
        if (base64List[i]) {
          self.imageList.push({
            // file: self.util.createFileFromUrl(base64List[i]),
            file: base64List[i],
            original: base64List[i],
            preview: '',
            comment: '',
            orientation: -1
          })
          self.util.resizeImage(
            self.imageList[self.imageList.length - 1].original,
            2048,
            2048,
            self.imageList[self.imageList.length - 1].orientation,
            loadOriginalImage(self.imageList.length - 1)
          )
          self.util.resizeImage(
            self.imageList[self.imageList.length - 1].original,
            640,
            640,
            self.imageList[self.imageList.length - 1].orientation,
            loadImage(self.imageList.length - 1)
          )
        }
      }

      self.$root.$emit('openModal', {
        name: 'AddPlaceImageForm',
        promptpaiDescription: self.detail,
        imageList: self.imageList
      })
      self.$refs[`add-image-input`].value = ''
    },
    openWebsite (url) {
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
    }
  },
  watch: {
    id () {
      var self = this
      self.$nextTick(() => {
        self.detail = undefined
        self.isFinished = false
        self.telList = []
        self.description(self.id)
      })
    },
    detail () {
      var self = this
      self.$nextTick(() => {
        if (self.detail) {
          self.updateHeight()
        }
      })
    },
    '$refs.header' () {
      var self = this
      self.$nextTick(() => {
        self.placeCardHeaderElement = self.$refs['header']
      })
    },
    $route (to, from) {
      const self = this
      if (self.$route.hash === '#modal' && self.isShowMenuPanel) {
        self.isShowMenuPanel = false
      }
    },
    step () {
      var self = this
      self.$nextTick(() => {
        if (self.step !== 'max') {
          self.$refs['detail'].scrollTop = 0
        }
      })
    }
  },
  beforeDestroy () {
    var self = this
    self.detail = undefined
    self.isFinished = false
  }
}
</script>

<style scoped>
  .place-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
    border-radius: 12.5px;
  }

  .place-card > .header {
    /* min-height: 68px; */
    width: 100%;
    background: rgb(34, 84, 156);
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    border-bottom: 1px solid rgb(227, 227, 227);
    border-radius: 12.5px 12.5px 0px 0px;
  }

  .place-card.min-step > .header {
    min-height: 73px;
  }

  .place-card > .header > .back-button,
  .place-card > .header > .menu-button {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    padding: 0px;
    border: none;
    cursor: pointer;
  }

  .place-card > .header > .menu-button {
    filter: invert(1) brightness(2);
  }

  .place-card.min-step > .header > .menu-button {
    display: none;
  }

  .place-card > .header > .back-button > img,
  .place-card > .header > .menu-button > img {
    width: 24px;
    height: 24px;
  }

  .place-card > .header > .title {
    box-sizing: border-box;
    width: calc(100% - 100px);
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: calc((74px - 30px - 28px) / 2) 0px calc((74px - 30px - 28px) / 2) 0px;
  }

  .place-card > .header > .title.full {
    width: calc(100% - 50px);
    padding: calc((74px - 30px - 28px) / 2) 16px calc((74px - 30px - 28px) / 2) 0px;
  }

  .place-card > .header > .title > .primary {
    font-size: 20px;
    font-weight: bold;
    font-family: Prompt;
    color: rgb(255, 255, 255);
  }

  .place-card.min-step > .header > .title > .primary {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .place-card > .header > .title > .secondary {
    font-size: 17px;
    font-family: Prompt;
    color: rgb(255, 255, 255);
    opacity: 0.85;
  }

  .place-card.min-step > .header > .title > .secondary {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .menu-panel {
    z-index: 90;
    position: absolute;
    top: 44px;
    right: 12.5px;
    background-color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2);
    border-radius: 12.5px;
    overflow: hidden;
  }

  .menu-panel > button {
    padding: 8px 16px;
    background-color: rgb(255, 255, 255);
    border: none;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
  }

  .menu-panel > button > img {
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }

  .menu-panel > button > .loading-img {
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }

  .menu-panel > button > .loading-img > div {
    transform: scale(0.3);
    transform-origin: left top;
    margin: 0px !important;
  }

  .menu-panel > button > div {
    font-family: Prompt;
  }

  .action-button-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: rgb(255, 255, 255);
    border-bottom: 1px solid rgb(227, 227, 227);
    overflow: hidden;
    min-height: 62px;
  }

  .action-button-container > button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: none;
    background-color: rgb(255, 255, 255);
    padding: 8px 0px 8px 0px;
    flex: 1;
    cursor: pointer;
    outline: none;
  }

  .action-button-container > button.disable {
    cursor: default;
  }

  .action-button-container > button > img {
    width: 24px;
    height: 24px;
    padding: 2px;
    box-sizing: border-box;
  }

  .action-button-container > button > label {
    cursor: pointer;
    font-family: Prompt;
    margin-top: 4px;
  }

  .action-button-container > button.disable > label {
    color: rgb(175, 175, 175);
    cursor: default;
  }

  .detail {
    background-color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow-y: auto;
    /* max-height: calc(100vh - 40px - 20px - 50px - 20px - 50px - 54px - 20px); */
    max-height: calc(100vh - 40px - 20px - 50px - 20px - 50px - 54px - 20px - 127px);
    box-sizing: border-box;
    border-radius: 0px 0px 12.5px 12.5px;
  }

  .detail::-webkit-scrollbar {
    background-color: rgb(255, 255, 255);
  }
  .detail::-webkit-scrollbar-thumb {
    border: 2px solid rgb(255, 255, 255);
  }

  .error-message {
    text-align: center;
    padding: 16px 8px;
    color: rgb(120, 120, 120);
    line-height: 1.75;
  }

  .promtpai-code {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 8px 16px 0px 16px;
  }

  .promtpai-code > div {
    position: relative;
  }

  .promtpai-code > div > .copied {
    position: absolute;
    color: rgb(255, 255, 255);
    background-color: rgb(0, 0, 0, 0.75);
    width: fit-content;
    border-radius: 16px;
    width: 75px;
    height: 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 26px;
    left: calc(((100% - 75px) / 2) - 8px);
  }

  .promtpai-code > div > iframe {
    border: none;
    overflow: hidden;
    margin-right: 16px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 2s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .detail .detail-list {
    padding: 8px 0px 16px 0px;
  }
  
  .detail .field {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  }

  .detail .field .icon-container {
    width: 48px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .detail .field .icon-container > img {
    height: 24px;
    display: block;
  }

  .detail .field label {
    width: calc(100% - 48px);
    padding: calc((36px - 24px) / 2) calc((36px - 24px) / 2) 0px 0px;
    box-sizing: border-box;
    min-height: 26px;
    line-height: 1.75;
  }

  .detail .field.tel label .can-call {
    color: rgb(34, 84, 156);
    cursor: pointer;
    text-decoration: none;
  }

  .detail .field.tel label .to {
    margin-left: -3px;
  }

  .detail .field.tel label > span {
    margin-right: 8px;
    word-break: break-all;
  }

  .detail .field.working label {
    display: flex;
    flex-direction: column;
  }

  .detail .field.working label > div {
    display: flex;
    flex-direction: row;
  }

  .detail .field.working label .day {
    width: 48px;
  }

  .detail .field.working label .start {
    width: 40px;
    text-align: right;
  }

  .detail .field.working label .to {
    width: 24px;
    text-align: center;
  }

  .detail .field.working label .end {
    width: 40px;
    text-align: left;
  }

  .detail .field.website label a {
    color: rgb(34, 84, 156);
    cursor: pointer;
    text-decoration: none;
    word-break: break-all;
  }

  .log {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    padding: 8px 16px 4px 16px;
    box-sizing: border-box;
  }

  .creater {
    font-size: 14px;
    color: rgb(115, 115, 115);
    text-align: left;
  }

  .update-date-time {
    font-size: 14px;
    color: rgb(115, 115, 115);
    text-align: left;
  }

  /* .image-list {
    width: calc(100% - 32px);
    margin: 0px 16px 16px 16px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .image-list > .image-container {
    width: calc((100% - 3px) / 4);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .image-list > .image-container.not-first {
    margin-left: 1px;
    margin-right: auto;
  }

  .image-list > .image-container > img {
    padding: 0px;
    cursor: pointer;
    width: 100%;
    height: 100%;
  }

  .image-list > .count-image {
    position: absolute;
    right: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(255, 255, 255);
    font-size: 36px;
    cursor: pointer;
    user-select: none;
  } */

  .image-list {
    width: calc(100% - 32px);
    margin: 0px 16px 16px 16px;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .image-list > .image-container {
    width: calc((100% - 24px) / 4);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;
  }

  .image-list > .image-container:before {
    content: "";
    display: block;
    padding-top: 100%;
    overflow: hidden;
    /* initial ratio of 1:1*/
  }

  .image-list > .image-container.add:first-child {
    border: 2px solid rgb(34, 84, 156);
    border-radius: 4px;
    cursor: pointer;
    opacity: 0.8;
  }

  .image-list > .image-container:not(:nth-child(4n)) {
    margin-right: 8px;
  }

  .image-list > .image-container:last-child {
    margin-right: auto;
  }

  .image-list > .image-container > img {
    padding: 0px;
    cursor: pointer;
    width: 100%;
    height: 100%;
    object-fit: contain;
    overflow: hidden;
  }

  .image-list > .image-container.add:first-child > img {
    padding: 24px;
    width: calc(100% - 48px);
    height: calc(100% - 48px);
  }

  .shadow-on-map {
    display: none;
  }

  #place-map {
    display: none;
  }

  button.current-location-button,
  button.zoom-in-button,
  button.zoom-out-button {
    background-color: #22549C;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid rgb(255, 255, 255);
    border-radius: 50%;
    padding: 0px;
    margin: 8px 0px 0px 0px;
    cursor: pointer;
  }

  button.zoom-out-button {
    margin-bottom: 8px;
  }

  button.current-location-button > img,
  button.zoom-in-button > img,
  button.zoom-out-button > img {
    width: 16px;
    height: 16px;
    display: block;
  }

  /**
  * ----------------------------------------
  * animation fav loading
  * ----------------------------------------
  */

  .fav-loading-animation {
    margin: auto;
    background-image: url(/static/image_asset/fav_loading@3x.png);
    background-size: 24px;
    width: 24px;
    height: 24px;
    animation: fav-loading-keyframes steps(10, end) 1s infinite;
    -webkit-animation: fav-loading-keyframes steps(10, end) 1s infinite;
  }

  .fav-loading-animation.reverse {
    animation-direction: reverse;
  }

  @keyframes fav-loading-keyframes {
    0% {background-position-y: calc(10 * 24px);}
    100% {background-position-y: 0px;}
  }

  @-webkit-keyframes fav-loading-keyframes {
    0% {background-position-y: calc(10 * 24px);}
    100% {background-position-y: 0px;}
  }

  @media only screen and (max-width: 768px) {
    .place-card {
      height: 100%;
      border-radius: 0px;
    }

    .place-card > .header {
      border-radius: 0px;
    }

    .loading-animation {
      margin-top: 16px;
    }

    /* .detail {
      height: calc(100% - 50px - 54px);
      max-height: unset;
    } */

    .detail {
      height: calc(100% - 130px);
      max-height: calc(100% - 130px);
      overflow: hidden;
      border-radius: 0px;
    }

    .detail.max-step {
      overflow-y: auto;
    }

    /* .image-list {
      width: 100%;
      margin: 0px 0px 0px 0px;
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    } */

    .shadow-on-map {
      display: block;
      position: absolute;
      top: 0px;
      height: 4px;
      width: 100%;
      z-index: 12;
      background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
    }

    #place-map {
      display: unset;
      min-height: 200px;
    }
  }

  @media only screen and (max-width: 420px) {
    .image-list > .image-container {
      width: calc((100% - 16px) / 3);
    }

    .image-list > .image-container:not(:nth-child(4n)) {
      margin-right: 0px;
    }

    .image-list > .image-container:not(:nth-child(3n)) {
      margin-right: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PlaceCard.vue